import React from 'react';
import ReportsBoxscores from '../components/Reports/ReportsBoxscores';
import '../components/LiveIntel/liveIntel.css';
import '../components/Reports/reports.css';

const ReportsBoxscoresPage = () => <ReportsBoxscores />;

export default ReportsBoxscoresPage;
